import { useState } from 'react';

import { logEvent } from 'common/helpers/internalAnalytics';

const useAnalytics = (func, category, title) => {
  const [isRun, setIsRun] = useState(false);
  const isTrue = func();
  if (isTrue) {
    if (!isRun) {
      logEvent(category, title);
      setIsRun(true);
    }
  }
};

export default useAnalytics;
